import { useState, useCallback } from "react";
import { Toast, ToastHeader, ToastBody } from "reactstrap";
import "../../assets/scss/custom/components/_toast.scss";

function useToast() {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<string>("");
  const [toastTitle, setToastTitle] = useState<string>("Notification");
  const [exiting, setExiting] = useState(false);

  const show = useCallback((title: string, message: string) => {
    setToastTitle(title);
    setToastMessage(message);

    setShowToast(true);

    setTimeout(() => {
      setExiting(true);
      setTimeout(() => {
        setShowToast(false);
        setExiting(false);
      }, 500);
    }, 5000);
  }, []);

  const hide = useCallback(() => {
    setExiting(true);
    setTimeout(() => {
      setShowToast(false);
      setExiting(false);
    }, 500);
  }, []);

  const ToastComponent = (
    <Toast
      isOpen={showToast}
      className={`position-fixed bottom-0 end-0 m-3 danger ${
        exiting ? "toast-slide-out" : "toast-slide-in"
      }`}
      style={{ zIndex: 1000 }}
    >
      <ToastHeader toggle={hide}>{toastTitle}</ToastHeader>
      <ToastBody>{toastMessage}</ToastBody>
    </Toast>
  );

  return {
    show,
    ToastComponent,
  };
}

export default useToast;
